<template>
  <div class="navbar-container">
    <div class="item" @click="activeChange(form.sellSort, 'sellSort')">
      <div class="text">销售额</div>
      <div class="arr">
        <Icon
          name="play"
          class="arr-up"
          :class="{ active: form.sellSort === false }"
        />
        <Icon
          name="play"
          class="arr-down"
          :class="{ active: form.sellSort === true }"
        />
      </div>
    </div>
    <div
      class="item"
      @click="activeChange(form.createTimeSort, 'createTimeSort')"
    >
      <div class="text">注册时间</div>
      <div class="arr">
        <Icon
          name="play"
          class="arr-up"
          :class="{ active: form.createTimeSort === false }"
        />
        <Icon
          name="play"
          class="arr-down"
          :class="{ active: form.createTimeSort === true }"
        />
      </div>
    </div>
    <div class="item" @click="activeChange(form.rankSort, 'rankSort')">
      <div class="text">等级</div>
      <div class="arr">
        <Icon
          name="play"
          class="arr-up"
          :class="{ active: form.rankSort === false }"
        />
        <Icon
          name="play"
          class="arr-down"
          :class="{ active: form.rankSort === true }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'
export default {
  components: { Icon },
  data() {
    return {
      form: {
        sellSort: null,
        createTimeSort: null,
        rankSort: null,
      },
    }
  },
  methods: {
    activeChange(flag, key) {
      this.cancelOther(key)
      if (flag === null) {
        this.form[key] = true
      } else if (flag === true) {
        this.form[key] = false
      } else {
        this.form[key] = null
      }
      this.$emit('getData')
    },
    cancelOther(key) {
      for (const _key in this.form) {
        if (Object.hasOwnProperty.call(this.form, _key)) {
          if (key !== _key) {
            this.form[_key] = null
          }
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.navbar-container {
  display: flex;
  padding: 32px 24px 28px;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-width: 0;
    .text {
      font-size: 26px;
      font-weight: 500;
      color: #333333;
      line-height: 1em;
    }
    .arr {
      display: flex;
      flex-direction: column;
      padding-left: 8px;
      [class^='arr-'] {
        display: inline-block;
        font-size: 22px;
        color: #c6c6c6;
      }
      .arr-up {
        margin-bottom: -10px;
        transform: rotate(-90deg);
      }
      .arr-down {
        transform: rotate(90deg);
      }
      .active {
        color: #e82035;
      }
    }
  }
}
</style>